<template>
    <section class="container">
        <div class="row">
            <div class="col-md-6">
                <div class="alert fade show" :class="clase">
                    <template v-if="estado===1">
                        <div class="alert-icon"><i class="fa fa-info-circle"></i></div>
                        <div class="alert-text">
                            1<sup>ro</sup> Coloque número de orden. <br>
                            2<sup>do</sup> Seleccione la agencia donde dejó su vehículo
                        </div>
                    </template>
                    <template v-else-if="estado===2">
                        <div class="alert-icon"><i class="fa fa-times-circle"></i></div>
                        <div class="alert-text">
                            No se encontró resultados
                        </div>
                    </template>
                    <template v-else-if="estado===3">
                        <div class="alert-icon"><i class="fa fa-spinner fa-spin"></i></div>
                        <div class="alert-text">
                            Cargando
                        </div>
                    </template>
                    <template v-else>
                        <div class="alert-icon"><i class="fa fa-car"></i></div>
                        <div class="alert-text">
                            Se encontró <br>
                            <b>{{formulario.datos.dt7}} {{formulario.datos.dt6}}</b>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div class="row pb-2">
            <div class="col-md-6">
                <div class="form-group">
                    <form v-on:submit.prevent="validar">
                        <label>Colocar número de orden de trabajo</label>
                        <div class="kt-input-icon kt-input-icon--left">
                            <input type="text" class="form-control" :placeholder="ano+'098765542'" name="orden" v-model="formulario.orden" v-validate="{required:true}"/>
                            <span class="kt-input-icon__icon kt-input-icon__icon--left">
                                <span><i class="la la-barcode"></i></span>
                            </span>
                        </div>
                    </form>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label>Seleccione el taller dónde dejo su vehículo</label>
                    <div class="kt-input-icon kt-input-icon--left">
                        <input type="text" class="form-control" placeholder="Quito" v-model="filtro" />
                        <span class="kt-input-icon__icon kt-input-icon__icon--left">
                                <span><i class="fa fa-search"></i></span>
                            </span>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <mapa v-model="formulario.agencia" :filtro="filtro"></mapa>
        </div>
        <div class="row p-3 d-flex justify-content-between">
            <button type="button" class="btn btn-lg btn-secondary btn-font-sm" v-on:click="atras"><i class="flaticon2-back"></i> Regresar</button>
            <button type="button" class="btn btn-lg btn-primary btn-font-sm" v-on:click="siguiente" > Continuar <i class="flaticon2-next"></i></button>
        </div>
    </section>
</template>
<script>
import mapa from "@/componentes/kia-mapa";
import * as servicios from "../servicios";
    export default {
        name: "paso-1",
        data:()=>({
            datos:null,
            formulario:{
                agencia: null,
                orden:null,
                datos:{},
            },
            filtro:null,
            ano:new Date().getFullYear(),
            estado:1,
            clase:'alert-outline-dark',
        }),
        watch:{
            "formulario.agencia":function(){
                this.validar();
            },
            estado:function(val){
                switch (val) {
                    case 1:
                        this.clase="alert-outline-dark";
                        break;
                    case 2:
                        this.clase="alert-danger";
                        break;
                    case 3:
                        this.clase="alert-warning";
                        break;
                    case 4:
                        this.clase="alert-outline-success";
                        break;
                }
            }
        },
        components :{
            mapa
        },
        methods:{
            atras:function(){
                this.$store.commit('setActual', null);
                this.$router.push({ name: 'Home' });
            },
            validar:function(){
                this.$validator.validateAll().then((result) => {
                    if(result && this.formulario.agencia){
                        this.estado=3;
                        servicios.orden.consultar(this.formulario).then(response=>{
                            this.formulario.datos=response.data;
                            if(response.data!==null){
                                this.estado=4;
                                this.$store.commit('setPaso',{data:this.formulario,p:1});
                                this.formulario.orden=null;
                                this.siguiente();
                            }else
                                this.estado=2;

                        }).catch(()=>{
                          this.estado = 2;
                        })
                    }else{
                        this.$toast.error("Ingrese el número de orden de trabajo y <br> seleccione un taller");
                    }
                });
            },
            siguiente:function(){
                if(this.estado===4){
                    this.$store.commit('setActual', 2);
                    this.$router.push({ name: 'p2' });
                }else{
                    this.validar();
                }
            }
        },
        created() {
            this.$store.commit('setActual', 1);
        }
    }
</script>
<style scoped>
    .form-group {
        margin-bottom: 0px !important;
    }
</style>
